export default "__VITE_ASSET__DIzlYnt$__"